
        // ! automatically generated - Don't change this file manually
        import load from '@loadable/component';
        import React from 'react';
        import PropTypes from 'prop-types';


        const LazyIcon2Layers = load(() => import('./Icon2Layers/index').then((m) => ({ default: m.Icon2Layers })), { ssr: false });
const LazyIcon3Dots = load(() => import('./Icon3Dots/index').then((m) => ({ default: m.Icon3Dots })), { ssr: false });
const LazyIcon3Layers = load(() => import('./Icon3Layers/index').then((m) => ({ default: m.Icon3Layers })), { ssr: false });
const LazyIconFiltersLines = load(() => import('./IconFiltersLines/index').then((m) => ({ default: m.IconFiltersLines })), { ssr: false });
const LazyIconActivity = load(() => import('./IconActivity/index').then((m) => ({ default: m.IconActivity })), { ssr: false });
const LazyIconAirplay = load(() => import('./IconAirplay/index').then((m) => ({ default: m.IconAirplay })), { ssr: false });
const LazyIconAlertCircle = load(() => import('./IconAlertCircle/index').then((m) => ({ default: m.IconAlertCircle })), { ssr: false });
const LazyIconAlertOctagon = load(() => import('./IconAlertOctagon/index').then((m) => ({ default: m.IconAlertOctagon })), { ssr: false });
const LazyIconAlertTriangle = load(() => import('./IconAlertTriangle/index').then((m) => ({ default: m.IconAlertTriangle })), { ssr: false });
const LazyIconAlignCenter = load(() => import('./IconAlignCenter/index').then((m) => ({ default: m.IconAlignCenter })), { ssr: false });
const LazyIconAlignJustify = load(() => import('./IconAlignJustify/index').then((m) => ({ default: m.IconAlignJustify })), { ssr: false });
const LazyIconAlignLeft = load(() => import('./IconAlignLeft/index').then((m) => ({ default: m.IconAlignLeft })), { ssr: false });
const LazyIconAlignRight = load(() => import('./IconAlignRight/index').then((m) => ({ default: m.IconAlignRight })), { ssr: false });
const LazyIconAnchor = load(() => import('./IconAnchor/index').then((m) => ({ default: m.IconAnchor })), { ssr: false });
const LazyIconAperture = load(() => import('./IconAperture/index').then((m) => ({ default: m.IconAperture })), { ssr: false });
const LazyIconArchive = load(() => import('./IconArchive/index').then((m) => ({ default: m.IconArchive })), { ssr: false });
const LazyIconArrowDownCircle = load(() => import('./IconArrowDownCircle/index').then((m) => ({ default: m.IconArrowDownCircle })), { ssr: false });
const LazyIconArrowDownLeft = load(() => import('./IconArrowDownLeft/index').then((m) => ({ default: m.IconArrowDownLeft })), { ssr: false });
const LazyIconArrowDownRight = load(() => import('./IconArrowDownRight/index').then((m) => ({ default: m.IconArrowDownRight })), { ssr: false });
const LazyIconArrowDown = load(() => import('./IconArrowDown/index').then((m) => ({ default: m.IconArrowDown })), { ssr: false });
const LazyIconArrowLeftCircle = load(() => import('./IconArrowLeftCircle/index').then((m) => ({ default: m.IconArrowLeftCircle })), { ssr: false });
const LazyIconArrowLeft = load(() => import('./IconArrowLeft/index').then((m) => ({ default: m.IconArrowLeft })), { ssr: false });
const LazyIconArrowRightCircle = load(() => import('./IconArrowRightCircle/index').then((m) => ({ default: m.IconArrowRightCircle })), { ssr: false });
const LazyIconArrowRight = load(() => import('./IconArrowRight/index').then((m) => ({ default: m.IconArrowRight })), { ssr: false });
const LazyIconArrowUpCircle = load(() => import('./IconArrowUpCircle/index').then((m) => ({ default: m.IconArrowUpCircle })), { ssr: false });
const LazyIconArrowUpLeft = load(() => import('./IconArrowUpLeft/index').then((m) => ({ default: m.IconArrowUpLeft })), { ssr: false });
const LazyIconArrowUpRight = load(() => import('./IconArrowUpRight/index').then((m) => ({ default: m.IconArrowUpRight })), { ssr: false });
const LazyIconArrowUp = load(() => import('./IconArrowUp/index').then((m) => ({ default: m.IconArrowUp })), { ssr: false });
const LazyIconAtSign = load(() => import('./IconAtSign/index').then((m) => ({ default: m.IconAtSign })), { ssr: false });
const LazyIconAward = load(() => import('./IconAward/index').then((m) => ({ default: m.IconAward })), { ssr: false });
const LazyIconBarChart2 = load(() => import('./IconBarChart2/index').then((m) => ({ default: m.IconBarChart2 })), { ssr: false });
const LazyIconBarChart = load(() => import('./IconBarChart/index').then((m) => ({ default: m.IconBarChart })), { ssr: false });
const LazyIconBatteryCharging = load(() => import('./IconBatteryCharging/index').then((m) => ({ default: m.IconBatteryCharging })), { ssr: false });
const LazyIconBattery = load(() => import('./IconBattery/index').then((m) => ({ default: m.IconBattery })), { ssr: false });
const LazyIconBellOff = load(() => import('./IconBellOff/index').then((m) => ({ default: m.IconBellOff })), { ssr: false });
const LazyIconBell = load(() => import('./IconBell/index').then((m) => ({ default: m.IconBell })), { ssr: false });
const LazyIconBluetooth = load(() => import('./IconBluetooth/index').then((m) => ({ default: m.IconBluetooth })), { ssr: false });
const LazyIconBold = load(() => import('./IconBold/index').then((m) => ({ default: m.IconBold })), { ssr: false });
const LazyIconBookOpen = load(() => import('./IconBookOpen/index').then((m) => ({ default: m.IconBookOpen })), { ssr: false });
const LazyIconBook = load(() => import('./IconBook/index').then((m) => ({ default: m.IconBook })), { ssr: false });
const LazyIconBookmark = load(() => import('./IconBookmark/index').then((m) => ({ default: m.IconBookmark })), { ssr: false });
const LazyIconBox = load(() => import('./IconBox/index').then((m) => ({ default: m.IconBox })), { ssr: false });
const LazyIconBriefcase = load(() => import('./IconBriefcase/index').then((m) => ({ default: m.IconBriefcase })), { ssr: false });
const LazyIconCalendar = load(() => import('./IconCalendar/index').then((m) => ({ default: m.IconCalendar })), { ssr: false });
const LazyIconCameraOff = load(() => import('./IconCameraOff/index').then((m) => ({ default: m.IconCameraOff })), { ssr: false });
const LazyIconCamera = load(() => import('./IconCamera/index').then((m) => ({ default: m.IconCamera })), { ssr: false });
const LazyIconCast = load(() => import('./IconCast/index').then((m) => ({ default: m.IconCast })), { ssr: false });
const LazyIconCheckCircle = load(() => import('./IconCheckCircle/index').then((m) => ({ default: m.IconCheckCircle })), { ssr: false });
const LazyIconCheckSquare = load(() => import('./IconCheckSquare/index').then((m) => ({ default: m.IconCheckSquare })), { ssr: false });
const LazyIconCheck = load(() => import('./IconCheck/index').then((m) => ({ default: m.IconCheck })), { ssr: false });
const LazyIconChevronDown = load(() => import('./IconChevronDown/index').then((m) => ({ default: m.IconChevronDown })), { ssr: false });
const LazyIconChevronLeft = load(() => import('./IconChevronLeft/index').then((m) => ({ default: m.IconChevronLeft })), { ssr: false });
const LazyIconChevronRight = load(() => import('./IconChevronRight/index').then((m) => ({ default: m.IconChevronRight })), { ssr: false });
const LazyIconChevronUp = load(() => import('./IconChevronUp/index').then((m) => ({ default: m.IconChevronUp })), { ssr: false });
const LazyIconChevronsDown = load(() => import('./IconChevronsDown/index').then((m) => ({ default: m.IconChevronsDown })), { ssr: false });
const LazyIconChevronsLeft = load(() => import('./IconChevronsLeft/index').then((m) => ({ default: m.IconChevronsLeft })), { ssr: false });
const LazyIconChevronsRight = load(() => import('./IconChevronsRight/index').then((m) => ({ default: m.IconChevronsRight })), { ssr: false });
const LazyIconChevronsUp = load(() => import('./IconChevronsUp/index').then((m) => ({ default: m.IconChevronsUp })), { ssr: false });
const LazyIconChrome = load(() => import('./IconChrome/index').then((m) => ({ default: m.IconChrome })), { ssr: false });
const LazyIconCircle = load(() => import('./IconCircle/index').then((m) => ({ default: m.IconCircle })), { ssr: false });
const LazyIconClipboard = load(() => import('./IconClipboard/index').then((m) => ({ default: m.IconClipboard })), { ssr: false });
const LazyIconClock = load(() => import('./IconClock/index').then((m) => ({ default: m.IconClock })), { ssr: false });
const LazyIconCloudDrizzle = load(() => import('./IconCloudDrizzle/index').then((m) => ({ default: m.IconCloudDrizzle })), { ssr: false });
const LazyIconCloudLightning = load(() => import('./IconCloudLightning/index').then((m) => ({ default: m.IconCloudLightning })), { ssr: false });
const LazyIconCloudOff = load(() => import('./IconCloudOff/index').then((m) => ({ default: m.IconCloudOff })), { ssr: false });
const LazyIconCloudRain = load(() => import('./IconCloudRain/index').then((m) => ({ default: m.IconCloudRain })), { ssr: false });
const LazyIconCloudSnow = load(() => import('./IconCloudSnow/index').then((m) => ({ default: m.IconCloudSnow })), { ssr: false });
const LazyIconCloud = load(() => import('./IconCloud/index').then((m) => ({ default: m.IconCloud })), { ssr: false });
const LazyIconCode = load(() => import('./IconCode/index').then((m) => ({ default: m.IconCode })), { ssr: false });
const LazyIconCodepen = load(() => import('./IconCodepen/index').then((m) => ({ default: m.IconCodepen })), { ssr: false });
const LazyIconCodesandbox = load(() => import('./IconCodesandbox/index').then((m) => ({ default: m.IconCodesandbox })), { ssr: false });
const LazyIconCoffee = load(() => import('./IconCoffee/index').then((m) => ({ default: m.IconCoffee })), { ssr: false });
const LazyIconCoinStack = load(() => import('./IconCoinStack/index').then((m) => ({ default: m.IconCoinStack })), { ssr: false });
const LazyIconCoins = load(() => import('./IconCoins/index').then((m) => ({ default: m.IconCoins })), { ssr: false });
const LazyIconColumns = load(() => import('./IconColumns/index').then((m) => ({ default: m.IconColumns })), { ssr: false });
const LazyIconCommand = load(() => import('./IconCommand/index').then((m) => ({ default: m.IconCommand })), { ssr: false });
const LazyIconCompass = load(() => import('./IconCompass/index').then((m) => ({ default: m.IconCompass })), { ssr: false });
const LazyIconCopy = load(() => import('./IconCopy/index').then((m) => ({ default: m.IconCopy })), { ssr: false });
const LazyIconCornerDownLeft = load(() => import('./IconCornerDownLeft/index').then((m) => ({ default: m.IconCornerDownLeft })), { ssr: false });
const LazyIconCornerDownRight = load(() => import('./IconCornerDownRight/index').then((m) => ({ default: m.IconCornerDownRight })), { ssr: false });
const LazyIconCornerLeftDown = load(() => import('./IconCornerLeftDown/index').then((m) => ({ default: m.IconCornerLeftDown })), { ssr: false });
const LazyIconCornerLeftUp = load(() => import('./IconCornerLeftUp/index').then((m) => ({ default: m.IconCornerLeftUp })), { ssr: false });
const LazyIconCornerRightDown = load(() => import('./IconCornerRightDown/index').then((m) => ({ default: m.IconCornerRightDown })), { ssr: false });
const LazyIconCornerRightUp = load(() => import('./IconCornerRightUp/index').then((m) => ({ default: m.IconCornerRightUp })), { ssr: false });
const LazyIconCornerUpLeft = load(() => import('./IconCornerUpLeft/index').then((m) => ({ default: m.IconCornerUpLeft })), { ssr: false });
const LazyIconCornerUpRight = load(() => import('./IconCornerUpRight/index').then((m) => ({ default: m.IconCornerUpRight })), { ssr: false });
const LazyIconCpu = load(() => import('./IconCpu/index').then((m) => ({ default: m.IconCpu })), { ssr: false });
const LazyIconCreditCard = load(() => import('./IconCreditCard/index').then((m) => ({ default: m.IconCreditCard })), { ssr: false });
const LazyIconCrop = load(() => import('./IconCrop/index').then((m) => ({ default: m.IconCrop })), { ssr: false });
const LazyIconCrosshair = load(() => import('./IconCrosshair/index').then((m) => ({ default: m.IconCrosshair })), { ssr: false });
const LazyIconDatabase = load(() => import('./IconDatabase/index').then((m) => ({ default: m.IconDatabase })), { ssr: false });
const LazyIconDelete = load(() => import('./IconDelete/index').then((m) => ({ default: m.IconDelete })), { ssr: false });
const LazyIconDisc = load(() => import('./IconDisc/index').then((m) => ({ default: m.IconDisc })), { ssr: false });
const LazyIconDivideCircle = load(() => import('./IconDivideCircle/index').then((m) => ({ default: m.IconDivideCircle })), { ssr: false });
const LazyIconDivideSquare = load(() => import('./IconDivideSquare/index').then((m) => ({ default: m.IconDivideSquare })), { ssr: false });
const LazyIconDivide = load(() => import('./IconDivide/index').then((m) => ({ default: m.IconDivide })), { ssr: false });
const LazyIconDivider = load(() => import('./IconDivider/index').then((m) => ({ default: m.IconDivider })), { ssr: false });
const LazyIconDollarSign = load(() => import('./IconDollarSign/index').then((m) => ({ default: m.IconDollarSign })), { ssr: false });
const LazyIconDownloadCloud = load(() => import('./IconDownloadCloud/index').then((m) => ({ default: m.IconDownloadCloud })), { ssr: false });
const LazyIconDownload = load(() => import('./IconDownload/index').then((m) => ({ default: m.IconDownload })), { ssr: false });
const LazyIconDribbble = load(() => import('./IconDribbble/index').then((m) => ({ default: m.IconDribbble })), { ssr: false });
const LazyIconDroplet = load(() => import('./IconDroplet/index').then((m) => ({ default: m.IconDroplet })), { ssr: false });
const LazyIconEdit2 = load(() => import('./IconEdit2/index').then((m) => ({ default: m.IconEdit2 })), { ssr: false });
const LazyIconEdit3 = load(() => import('./IconEdit3/index').then((m) => ({ default: m.IconEdit3 })), { ssr: false });
const LazyIconEdit = load(() => import('./IconEdit/index').then((m) => ({ default: m.IconEdit })), { ssr: false });
const LazyIconExternalLink = load(() => import('./IconExternalLink/index').then((m) => ({ default: m.IconExternalLink })), { ssr: false });
const LazyIconEyeOff = load(() => import('./IconEyeOff/index').then((m) => ({ default: m.IconEyeOff })), { ssr: false });
const LazyIconEye = load(() => import('./IconEye/index').then((m) => ({ default: m.IconEye })), { ssr: false });
const LazyIconFacebook = load(() => import('./IconFacebook/index').then((m) => ({ default: m.IconFacebook })), { ssr: false });
const LazyIconFastForward = load(() => import('./IconFastForward/index').then((m) => ({ default: m.IconFastForward })), { ssr: false });
const LazyIconFeather = load(() => import('./IconFeather/index').then((m) => ({ default: m.IconFeather })), { ssr: false });
const LazyIconFigma = load(() => import('./IconFigma/index').then((m) => ({ default: m.IconFigma })), { ssr: false });
const LazyIconFileMinus = load(() => import('./IconFileMinus/index').then((m) => ({ default: m.IconFileMinus })), { ssr: false });
const LazyIconFilePlus = load(() => import('./IconFilePlus/index').then((m) => ({ default: m.IconFilePlus })), { ssr: false });
const LazyIconFileText = load(() => import('./IconFileText/index').then((m) => ({ default: m.IconFileText })), { ssr: false });
const LazyIconFile = load(() => import('./IconFile/index').then((m) => ({ default: m.IconFile })), { ssr: false });
const LazyIconFilm = load(() => import('./IconFilm/index').then((m) => ({ default: m.IconFilm })), { ssr: false });
const LazyIconFilter = load(() => import('./IconFilter/index').then((m) => ({ default: m.IconFilter })), { ssr: false });
const LazyIconFlag = load(() => import('./IconFlag/index').then((m) => ({ default: m.IconFlag })), { ssr: false });
const LazyIconFolderMinus = load(() => import('./IconFolderMinus/index').then((m) => ({ default: m.IconFolderMinus })), { ssr: false });
const LazyIconFolderPlus = load(() => import('./IconFolderPlus/index').then((m) => ({ default: m.IconFolderPlus })), { ssr: false });
const LazyIconFolder = load(() => import('./IconFolder/index').then((m) => ({ default: m.IconFolder })), { ssr: false });
const LazyIconFramer = load(() => import('./IconFramer/index').then((m) => ({ default: m.IconFramer })), { ssr: false });
const LazyIconFrown = load(() => import('./IconFrown/index').then((m) => ({ default: m.IconFrown })), { ssr: false });
const LazyIconGift = load(() => import('./IconGift/index').then((m) => ({ default: m.IconGift })), { ssr: false });
const LazyIconGitBranch = load(() => import('./IconGitBranch/index').then((m) => ({ default: m.IconGitBranch })), { ssr: false });
const LazyIconGitCommit = load(() => import('./IconGitCommit/index').then((m) => ({ default: m.IconGitCommit })), { ssr: false });
const LazyIconGitMerge = load(() => import('./IconGitMerge/index').then((m) => ({ default: m.IconGitMerge })), { ssr: false });
const LazyIconGitPullRequest = load(() => import('./IconGitPullRequest/index').then((m) => ({ default: m.IconGitPullRequest })), { ssr: false });
const LazyIconGithub = load(() => import('./IconGithub/index').then((m) => ({ default: m.IconGithub })), { ssr: false });
const LazyIconGitlab = load(() => import('./IconGitlab/index').then((m) => ({ default: m.IconGitlab })), { ssr: false });
const LazyIconGlobe = load(() => import('./IconGlobe/index').then((m) => ({ default: m.IconGlobe })), { ssr: false });
const LazyIconGrid = load(() => import('./IconGrid/index').then((m) => ({ default: m.IconGrid })), { ssr: false });
const LazyIconHardDrive = load(() => import('./IconHardDrive/index').then((m) => ({ default: m.IconHardDrive })), { ssr: false });
const LazyIconHash = load(() => import('./IconHash/index').then((m) => ({ default: m.IconHash })), { ssr: false });
const LazyIconHeadphones = load(() => import('./IconHeadphones/index').then((m) => ({ default: m.IconHeadphones })), { ssr: false });
const LazyIconHeart = load(() => import('./IconHeart/index').then((m) => ({ default: m.IconHeart })), { ssr: false });
const LazyIconHelpCircle = load(() => import('./IconHelpCircle/index').then((m) => ({ default: m.IconHelpCircle })), { ssr: false });
const LazyIconHexagon = load(() => import('./IconHexagon/index').then((m) => ({ default: m.IconHexagon })), { ssr: false });
const LazyIconHome = load(() => import('./IconHome/index').then((m) => ({ default: m.IconHome })), { ssr: false });
const LazyIconImage = load(() => import('./IconImage/index').then((m) => ({ default: m.IconImage })), { ssr: false });
const LazyIconInbox = load(() => import('./IconInbox/index').then((m) => ({ default: m.IconInbox })), { ssr: false });
const LazyIconInfo = load(() => import('./IconInfo/index').then((m) => ({ default: m.IconInfo })), { ssr: false });
const LazyIconInstagram = load(() => import('./IconInstagram/index').then((m) => ({ default: m.IconInstagram })), { ssr: false });
const LazyIconItalic = load(() => import('./IconItalic/index').then((m) => ({ default: m.IconItalic })), { ssr: false });
const LazyIconKey = load(() => import('./IconKey/index').then((m) => ({ default: m.IconKey })), { ssr: false });
const LazyIconLayers = load(() => import('./IconLayers/index').then((m) => ({ default: m.IconLayers })), { ssr: false });
const LazyIconLayout = load(() => import('./IconLayout/index').then((m) => ({ default: m.IconLayout })), { ssr: false });
const LazyIconLifeBuoy = load(() => import('./IconLifeBuoy/index').then((m) => ({ default: m.IconLifeBuoy })), { ssr: false });
const LazyIconLink2 = load(() => import('./IconLink2/index').then((m) => ({ default: m.IconLink2 })), { ssr: false });
const LazyIconLink = load(() => import('./IconLink/index').then((m) => ({ default: m.IconLink })), { ssr: false });
const LazyIconLinkedin = load(() => import('./IconLinkedin/index').then((m) => ({ default: m.IconLinkedin })), { ssr: false });
const LazyIconList = load(() => import('./IconList/index').then((m) => ({ default: m.IconList })), { ssr: false });
const LazyIconLoader = load(() => import('./IconLoader/index').then((m) => ({ default: m.IconLoader })), { ssr: false });
const LazyIconLocationPin = load(() => import('./IconLocationPin/index').then((m) => ({ default: m.IconLocationPin })), { ssr: false });
const LazyIconLock = load(() => import('./IconLock/index').then((m) => ({ default: m.IconLock })), { ssr: false });
const LazyIconLogIn = load(() => import('./IconLogIn/index').then((m) => ({ default: m.IconLogIn })), { ssr: false });
const LazyIconLogOut = load(() => import('./IconLogOut/index').then((m) => ({ default: m.IconLogOut })), { ssr: false });
const LazyIconMail = load(() => import('./IconMail/index').then((m) => ({ default: m.IconMail })), { ssr: false });
const LazyIconMapPin = load(() => import('./IconMapPin/index').then((m) => ({ default: m.IconMapPin })), { ssr: false });
const LazyIconMap = load(() => import('./IconMap/index').then((m) => ({ default: m.IconMap })), { ssr: false });
const LazyIconMaximize2 = load(() => import('./IconMaximize2/index').then((m) => ({ default: m.IconMaximize2 })), { ssr: false });
const LazyIconMaximize = load(() => import('./IconMaximize/index').then((m) => ({ default: m.IconMaximize })), { ssr: false });
const LazyIconMeh = load(() => import('./IconMeh/index').then((m) => ({ default: m.IconMeh })), { ssr: false });
const LazyIconMenu2 = load(() => import('./IconMenu2/index').then((m) => ({ default: m.IconMenu2 })), { ssr: false });
const LazyIconMenu = load(() => import('./IconMenu/index').then((m) => ({ default: m.IconMenu })), { ssr: false });
const LazyIconMessageCircle = load(() => import('./IconMessageCircle/index').then((m) => ({ default: m.IconMessageCircle })), { ssr: false });
const LazyIconMessageSquare = load(() => import('./IconMessageSquare/index').then((m) => ({ default: m.IconMessageSquare })), { ssr: false });
const LazyIconMicOff = load(() => import('./IconMicOff/index').then((m) => ({ default: m.IconMicOff })), { ssr: false });
const LazyIconMic = load(() => import('./IconMic/index').then((m) => ({ default: m.IconMic })), { ssr: false });
const LazyIconMinimize2 = load(() => import('./IconMinimize2/index').then((m) => ({ default: m.IconMinimize2 })), { ssr: false });
const LazyIconMinimize = load(() => import('./IconMinimize/index').then((m) => ({ default: m.IconMinimize })), { ssr: false });
const LazyIconMinusCircle = load(() => import('./IconMinusCircle/index').then((m) => ({ default: m.IconMinusCircle })), { ssr: false });
const LazyIconMinusSquare = load(() => import('./IconMinusSquare/index').then((m) => ({ default: m.IconMinusSquare })), { ssr: false });
const LazyIconMinus = load(() => import('./IconMinus/index').then((m) => ({ default: m.IconMinus })), { ssr: false });
const LazyIconMonitor = load(() => import('./IconMonitor/index').then((m) => ({ default: m.IconMonitor })), { ssr: false });
const LazyIconMoon = load(() => import('./IconMoon/index').then((m) => ({ default: m.IconMoon })), { ssr: false });
const LazyIconMoreHorizontal = load(() => import('./IconMoreHorizontal/index').then((m) => ({ default: m.IconMoreHorizontal })), { ssr: false });
const LazyIconMoreVertical = load(() => import('./IconMoreVertical/index').then((m) => ({ default: m.IconMoreVertical })), { ssr: false });
const LazyIconMousePointer = load(() => import('./IconMousePointer/index').then((m) => ({ default: m.IconMousePointer })), { ssr: false });
const LazyIconMove = load(() => import('./IconMove/index').then((m) => ({ default: m.IconMove })), { ssr: false });
const LazyIconMusic = load(() => import('./IconMusic/index').then((m) => ({ default: m.IconMusic })), { ssr: false });
const LazyIconNavigation2 = load(() => import('./IconNavigation2/index').then((m) => ({ default: m.IconNavigation2 })), { ssr: false });
const LazyIconNavigation = load(() => import('./IconNavigation/index').then((m) => ({ default: m.IconNavigation })), { ssr: false });
const LazyIconOctagon = load(() => import('./IconOctagon/index').then((m) => ({ default: m.IconOctagon })), { ssr: false });
const LazyIconPackage = load(() => import('./IconPackage/index').then((m) => ({ default: m.IconPackage })), { ssr: false });
const LazyIconPaperclip = load(() => import('./IconPaperclip/index').then((m) => ({ default: m.IconPaperclip })), { ssr: false });
const LazyIconPauseCircle = load(() => import('./IconPauseCircle/index').then((m) => ({ default: m.IconPauseCircle })), { ssr: false });
const LazyIconPause = load(() => import('./IconPause/index').then((m) => ({ default: m.IconPause })), { ssr: false });
const LazyIconPenTool = load(() => import('./IconPenTool/index').then((m) => ({ default: m.IconPenTool })), { ssr: false });
const LazyIconPercent = load(() => import('./IconPercent/index').then((m) => ({ default: m.IconPercent })), { ssr: false });
const LazyIconPhoneCall = load(() => import('./IconPhoneCall/index').then((m) => ({ default: m.IconPhoneCall })), { ssr: false });
const LazyIconPhoneForwarded = load(() => import('./IconPhoneForwarded/index').then((m) => ({ default: m.IconPhoneForwarded })), { ssr: false });
const LazyIconPhoneIncoming = load(() => import('./IconPhoneIncoming/index').then((m) => ({ default: m.IconPhoneIncoming })), { ssr: false });
const LazyIconPhoneMissed = load(() => import('./IconPhoneMissed/index').then((m) => ({ default: m.IconPhoneMissed })), { ssr: false });
const LazyIconPhoneOff = load(() => import('./IconPhoneOff/index').then((m) => ({ default: m.IconPhoneOff })), { ssr: false });
const LazyIconPhoneOutgoing = load(() => import('./IconPhoneOutgoing/index').then((m) => ({ default: m.IconPhoneOutgoing })), { ssr: false });
const LazyIconPhone = load(() => import('./IconPhone/index').then((m) => ({ default: m.IconPhone })), { ssr: false });
const LazyIconPieChart = load(() => import('./IconPieChart/index').then((m) => ({ default: m.IconPieChart })), { ssr: false });
const LazyIconPlayCircle = load(() => import('./IconPlayCircle/index').then((m) => ({ default: m.IconPlayCircle })), { ssr: false });
const LazyIconPlay = load(() => import('./IconPlay/index').then((m) => ({ default: m.IconPlay })), { ssr: false });
const LazyIconPlusCircle = load(() => import('./IconPlusCircle/index').then((m) => ({ default: m.IconPlusCircle })), { ssr: false });
const LazyIconPlusSquare = load(() => import('./IconPlusSquare/index').then((m) => ({ default: m.IconPlusSquare })), { ssr: false });
const LazyIconPlus = load(() => import('./IconPlus/index').then((m) => ({ default: m.IconPlus })), { ssr: false });
const LazyIconPocket = load(() => import('./IconPocket/index').then((m) => ({ default: m.IconPocket })), { ssr: false });
const LazyIconPower = load(() => import('./IconPower/index').then((m) => ({ default: m.IconPower })), { ssr: false });
const LazyIconPrinter = load(() => import('./IconPrinter/index').then((m) => ({ default: m.IconPrinter })), { ssr: false });
const LazyIconRadio = load(() => import('./IconRadio/index').then((m) => ({ default: m.IconRadio })), { ssr: false });
const LazyIconRating = load(() => import('./IconRating/index').then((m) => ({ default: m.IconRating })), { ssr: false });
const LazyIconRefreshCcw = load(() => import('./IconRefreshCcw/index').then((m) => ({ default: m.IconRefreshCcw })), { ssr: false });
const LazyIconRefreshCw = load(() => import('./IconRefreshCw/index').then((m) => ({ default: m.IconRefreshCw })), { ssr: false });
const LazyIconRepeat = load(() => import('./IconRepeat/index').then((m) => ({ default: m.IconRepeat })), { ssr: false });
const LazyIconRewind = load(() => import('./IconRewind/index').then((m) => ({ default: m.IconRewind })), { ssr: false });
const LazyIconRocket = load(() => import('./IconRocket/index').then((m) => ({ default: m.IconRocket })), { ssr: false });
const LazyIconRotateCcw = load(() => import('./IconRotateCcw/index').then((m) => ({ default: m.IconRotateCcw })), { ssr: false });
const LazyIconRotateCw = load(() => import('./IconRotateCw/index').then((m) => ({ default: m.IconRotateCw })), { ssr: false });
const LazyIconRss = load(() => import('./IconRss/index').then((m) => ({ default: m.IconRss })), { ssr: false });
const LazyIconSave = load(() => import('./IconSave/index').then((m) => ({ default: m.IconSave })), { ssr: false });
const LazyIconScissors = load(() => import('./IconScissors/index').then((m) => ({ default: m.IconScissors })), { ssr: false });
const LazyIconSearch = load(() => import('./IconSearch/index').then((m) => ({ default: m.IconSearch })), { ssr: false });
const LazyIconSend = load(() => import('./IconSend/index').then((m) => ({ default: m.IconSend })), { ssr: false });
const LazyIconServer = load(() => import('./IconServer/index').then((m) => ({ default: m.IconServer })), { ssr: false });
const LazyIconSettings = load(() => import('./IconSettings/index').then((m) => ({ default: m.IconSettings })), { ssr: false });
const LazyIconShare2 = load(() => import('./IconShare2/index').then((m) => ({ default: m.IconShare2 })), { ssr: false });
const LazyIconShare = load(() => import('./IconShare/index').then((m) => ({ default: m.IconShare })), { ssr: false });
const LazyIconShieldOff = load(() => import('./IconShieldOff/index').then((m) => ({ default: m.IconShieldOff })), { ssr: false });
const LazyIconShield = load(() => import('./IconShield/index').then((m) => ({ default: m.IconShield })), { ssr: false });
const LazyIconShoppingBag = load(() => import('./IconShoppingBag/index').then((m) => ({ default: m.IconShoppingBag })), { ssr: false });
const LazyIconShoppingCart = load(() => import('./IconShoppingCart/index').then((m) => ({ default: m.IconShoppingCart })), { ssr: false });
const LazyIconShuffle = load(() => import('./IconShuffle/index').then((m) => ({ default: m.IconShuffle })), { ssr: false });
const LazyIconSidebar = load(() => import('./IconSidebar/index').then((m) => ({ default: m.IconSidebar })), { ssr: false });
const LazyIconSkipBack = load(() => import('./IconSkipBack/index').then((m) => ({ default: m.IconSkipBack })), { ssr: false });
const LazyIconSkipForward = load(() => import('./IconSkipForward/index').then((m) => ({ default: m.IconSkipForward })), { ssr: false });
const LazyIconSlack = load(() => import('./IconSlack/index').then((m) => ({ default: m.IconSlack })), { ssr: false });
const LazyIconSlashDivider = load(() => import('./IconSlashDivider/index').then((m) => ({ default: m.IconSlashDivider })), { ssr: false });
const LazyIconSlash = load(() => import('./IconSlash/index').then((m) => ({ default: m.IconSlash })), { ssr: false });
const LazyIconSliders = load(() => import('./IconSliders/index').then((m) => ({ default: m.IconSliders })), { ssr: false });
const LazyIconSmartphone = load(() => import('./IconSmartphone/index').then((m) => ({ default: m.IconSmartphone })), { ssr: false });
const LazyIconSmile = load(() => import('./IconSmile/index').then((m) => ({ default: m.IconSmile })), { ssr: false });
const LazyIconSpeaker = load(() => import('./IconSpeaker/index').then((m) => ({ default: m.IconSpeaker })), { ssr: false });
const LazyIconSquare = load(() => import('./IconSquare/index').then((m) => ({ default: m.IconSquare })), { ssr: false });
const LazyIconStar = load(() => import('./IconStar/index').then((m) => ({ default: m.IconStar })), { ssr: false });
const LazyIconStopCircle = load(() => import('./IconStopCircle/index').then((m) => ({ default: m.IconStopCircle })), { ssr: false });
const LazyIconSun = load(() => import('./IconSun/index').then((m) => ({ default: m.IconSun })), { ssr: false });
const LazyIconSunrise = load(() => import('./IconSunrise/index').then((m) => ({ default: m.IconSunrise })), { ssr: false });
const LazyIconSunset = load(() => import('./IconSunset/index').then((m) => ({ default: m.IconSunset })), { ssr: false });
const LazyIconTable = load(() => import('./IconTable/index').then((m) => ({ default: m.IconTable })), { ssr: false });
const LazyIconTablet = load(() => import('./IconTablet/index').then((m) => ({ default: m.IconTablet })), { ssr: false });
const LazyIconTag = load(() => import('./IconTag/index').then((m) => ({ default: m.IconTag })), { ssr: false });
const LazyIconTarget = load(() => import('./IconTarget/index').then((m) => ({ default: m.IconTarget })), { ssr: false });
const LazyIconTerminal = load(() => import('./IconTerminal/index').then((m) => ({ default: m.IconTerminal })), { ssr: false });
const LazyIconThermometer = load(() => import('./IconThermometer/index').then((m) => ({ default: m.IconThermometer })), { ssr: false });
const LazyIconThumbsDown = load(() => import('./IconThumbsDown/index').then((m) => ({ default: m.IconThumbsDown })), { ssr: false });
const LazyIconThumbsUp = load(() => import('./IconThumbsUp/index').then((m) => ({ default: m.IconThumbsUp })), { ssr: false });
const LazyIconToggleLeft = load(() => import('./IconToggleLeft/index').then((m) => ({ default: m.IconToggleLeft })), { ssr: false });
const LazyIconToggleRight = load(() => import('./IconToggleRight/index').then((m) => ({ default: m.IconToggleRight })), { ssr: false });
const LazyIconTool = load(() => import('./IconTool/index').then((m) => ({ default: m.IconTool })), { ssr: false });
const LazyIconTrash2 = load(() => import('./IconTrash2/index').then((m) => ({ default: m.IconTrash2 })), { ssr: false });
const LazyIconTrash = load(() => import('./IconTrash/index').then((m) => ({ default: m.IconTrash })), { ssr: false });
const LazyIconTrello = load(() => import('./IconTrello/index').then((m) => ({ default: m.IconTrello })), { ssr: false });
const LazyIconTrendingDown = load(() => import('./IconTrendingDown/index').then((m) => ({ default: m.IconTrendingDown })), { ssr: false });
const LazyIconTrendingUp = load(() => import('./IconTrendingUp/index').then((m) => ({ default: m.IconTrendingUp })), { ssr: false });
const LazyIconTriangle = load(() => import('./IconTriangle/index').then((m) => ({ default: m.IconTriangle })), { ssr: false });
const LazyIconTruck = load(() => import('./IconTruck/index').then((m) => ({ default: m.IconTruck })), { ssr: false });
const LazyIconTv = load(() => import('./IconTv/index').then((m) => ({ default: m.IconTv })), { ssr: false });
const LazyIconTwitch = load(() => import('./IconTwitch/index').then((m) => ({ default: m.IconTwitch })), { ssr: false });
const LazyIconTwitter = load(() => import('./IconTwitter/index').then((m) => ({ default: m.IconTwitter })), { ssr: false });
const LazyIconType = load(() => import('./IconType/index').then((m) => ({ default: m.IconType })), { ssr: false });
const LazyIconUmbrella = load(() => import('./IconUmbrella/index').then((m) => ({ default: m.IconUmbrella })), { ssr: false });
const LazyIconUnderline = load(() => import('./IconUnderline/index').then((m) => ({ default: m.IconUnderline })), { ssr: false });
const LazyIconUnlock = load(() => import('./IconUnlock/index').then((m) => ({ default: m.IconUnlock })), { ssr: false });
const LazyIconUploadCloud = load(() => import('./IconUploadCloud/index').then((m) => ({ default: m.IconUploadCloud })), { ssr: false });
const LazyIconUpload = load(() => import('./IconUpload/index').then((m) => ({ default: m.IconUpload })), { ssr: false });
const LazyIconUserCheck = load(() => import('./IconUserCheck/index').then((m) => ({ default: m.IconUserCheck })), { ssr: false });
const LazyIconUserMinus = load(() => import('./IconUserMinus/index').then((m) => ({ default: m.IconUserMinus })), { ssr: false });
const LazyIconUserPlus = load(() => import('./IconUserPlus/index').then((m) => ({ default: m.IconUserPlus })), { ssr: false });
const LazyIconUserX = load(() => import('./IconUserX/index').then((m) => ({ default: m.IconUserX })), { ssr: false });
const LazyIconUser = load(() => import('./IconUser/index').then((m) => ({ default: m.IconUser })), { ssr: false });
const LazyIconUsers = load(() => import('./IconUsers/index').then((m) => ({ default: m.IconUsers })), { ssr: false });
const LazyIconVideoOff = load(() => import('./IconVideoOff/index').then((m) => ({ default: m.IconVideoOff })), { ssr: false });
const LazyIconVideoPlayCircle = load(() => import('./IconVideoPlayCircle/index').then((m) => ({ default: m.IconVideoPlayCircle })), { ssr: false });
const LazyIconVideo = load(() => import('./IconVideo/index').then((m) => ({ default: m.IconVideo })), { ssr: false });
const LazyIconVoicemail = load(() => import('./IconVoicemail/index').then((m) => ({ default: m.IconVoicemail })), { ssr: false });
const LazyIconVolume1 = load(() => import('./IconVolume1/index').then((m) => ({ default: m.IconVolume1 })), { ssr: false });
const LazyIconVolume2 = load(() => import('./IconVolume2/index').then((m) => ({ default: m.IconVolume2 })), { ssr: false });
const LazyIconVolumeX = load(() => import('./IconVolumeX/index').then((m) => ({ default: m.IconVolumeX })), { ssr: false });
const LazyIconVolume = load(() => import('./IconVolume/index').then((m) => ({ default: m.IconVolume })), { ssr: false });
const LazyIconWatch = load(() => import('./IconWatch/index').then((m) => ({ default: m.IconWatch })), { ssr: false });
const LazyIconWifiOff = load(() => import('./IconWifiOff/index').then((m) => ({ default: m.IconWifiOff })), { ssr: false });
const LazyIconWifi = load(() => import('./IconWifi/index').then((m) => ({ default: m.IconWifi })), { ssr: false });
const LazyIconWind = load(() => import('./IconWind/index').then((m) => ({ default: m.IconWind })), { ssr: false });
const LazyIconXCircle = load(() => import('./IconXCircle/index').then((m) => ({ default: m.IconXCircle })), { ssr: false });
const LazyIconXOctagon = load(() => import('./IconXOctagon/index').then((m) => ({ default: m.IconXOctagon })), { ssr: false });
const LazyIconXSquare = load(() => import('./IconXSquare/index').then((m) => ({ default: m.IconXSquare })), { ssr: false });
const LazyIconX = load(() => import('./IconX/index').then((m) => ({ default: m.IconX })), { ssr: false });
const LazyIconYoutube = load(() => import('./IconYoutube/index').then((m) => ({ default: m.IconYoutube })), { ssr: false });
const LazyIconZapOff = load(() => import('./IconZapOff/index').then((m) => ({ default: m.IconZapOff })), { ssr: false });
const LazyIconZap = load(() => import('./IconZap/index').then((m) => ({ default: m.IconZap })), { ssr: false });
const LazyIconZoomIn = load(() => import('./IconZoomIn/index').then((m) => ({ default: m.IconZoomIn })), { ssr: false });
const LazyIconZoomOut = load(() => import('./IconZoomOut/index').then((m) => ({ default: m.IconZoomOut })), { ssr: false });

        const ICON_SIZE = { small: '1rem', medium: '1.25rem', large: '1.5rem' };

        export const Icon = React.forwardRef((props, ref) => {
            const {name, ...otherProps} = props

            return (
                <>
                    {(() => {
                        switch (name) {
                            case '2-layers':
                return (
                    <LazyIcon2Layers
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case '3-dots':
                return (
                    <LazyIcon3Dots
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case '3-layers':
                return (
                    <LazyIcon3Layers
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'filters-lines':
                return (
                    <LazyIconFiltersLines
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'activity':
                return (
                    <LazyIconActivity
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'airplay':
                return (
                    <LazyIconAirplay
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'alert-circle':
                return (
                    <LazyIconAlertCircle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'alert-octagon':
                return (
                    <LazyIconAlertOctagon
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'alert-triangle':
                return (
                    <LazyIconAlertTriangle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'align-center':
                return (
                    <LazyIconAlignCenter
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'align-justify':
                return (
                    <LazyIconAlignJustify
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'align-left':
                return (
                    <LazyIconAlignLeft
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'align-right':
                return (
                    <LazyIconAlignRight
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'anchor':
                return (
                    <LazyIconAnchor
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'aperture':
                return (
                    <LazyIconAperture
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'archive':
                return (
                    <LazyIconArchive
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'arrow-down-circle':
                return (
                    <LazyIconArrowDownCircle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'arrow-down-left':
                return (
                    <LazyIconArrowDownLeft
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'arrow-down-right':
                return (
                    <LazyIconArrowDownRight
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'arrow-down':
                return (
                    <LazyIconArrowDown
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'arrow-left-circle':
                return (
                    <LazyIconArrowLeftCircle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'arrow-left':
                return (
                    <LazyIconArrowLeft
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'arrow-right-circle':
                return (
                    <LazyIconArrowRightCircle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'arrow-right':
                return (
                    <LazyIconArrowRight
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'arrow-up-circle':
                return (
                    <LazyIconArrowUpCircle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'arrow-up-left':
                return (
                    <LazyIconArrowUpLeft
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'arrow-up-right':
                return (
                    <LazyIconArrowUpRight
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'arrow-up':
                return (
                    <LazyIconArrowUp
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'at-sign':
                return (
                    <LazyIconAtSign
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'award':
                return (
                    <LazyIconAward
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'bar-chart2':
                return (
                    <LazyIconBarChart2
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'bar-chart':
                return (
                    <LazyIconBarChart
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'battery-charging':
                return (
                    <LazyIconBatteryCharging
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'battery':
                return (
                    <LazyIconBattery
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'bell-off':
                return (
                    <LazyIconBellOff
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'bell':
                return (
                    <LazyIconBell
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'bluetooth':
                return (
                    <LazyIconBluetooth
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'bold':
                return (
                    <LazyIconBold
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'book-open':
                return (
                    <LazyIconBookOpen
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'book':
                return (
                    <LazyIconBook
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'bookmark':
                return (
                    <LazyIconBookmark
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'box':
                return (
                    <LazyIconBox
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'briefcase':
                return (
                    <LazyIconBriefcase
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'calendar':
                return (
                    <LazyIconCalendar
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'camera-off':
                return (
                    <LazyIconCameraOff
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'camera':
                return (
                    <LazyIconCamera
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'cast':
                return (
                    <LazyIconCast
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'check-circle':
                return (
                    <LazyIconCheckCircle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'check-square':
                return (
                    <LazyIconCheckSquare
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'check':
                return (
                    <LazyIconCheck
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'chevron-down':
                return (
                    <LazyIconChevronDown
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'chevron-left':
                return (
                    <LazyIconChevronLeft
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'chevron-right':
                return (
                    <LazyIconChevronRight
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'chevron-up':
                return (
                    <LazyIconChevronUp
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'chevrons-down':
                return (
                    <LazyIconChevronsDown
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'chevrons-left':
                return (
                    <LazyIconChevronsLeft
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'chevrons-right':
                return (
                    <LazyIconChevronsRight
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'chevrons-up':
                return (
                    <LazyIconChevronsUp
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'chrome':
                return (
                    <LazyIconChrome
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'circle':
                return (
                    <LazyIconCircle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'clipboard':
                return (
                    <LazyIconClipboard
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'clock':
                return (
                    <LazyIconClock
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'cloud-drizzle':
                return (
                    <LazyIconCloudDrizzle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'cloud-lightning':
                return (
                    <LazyIconCloudLightning
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'cloud-off':
                return (
                    <LazyIconCloudOff
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'cloud-rain':
                return (
                    <LazyIconCloudRain
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'cloud-snow':
                return (
                    <LazyIconCloudSnow
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'cloud':
                return (
                    <LazyIconCloud
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'code':
                return (
                    <LazyIconCode
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'codepen':
                return (
                    <LazyIconCodepen
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'codesandbox':
                return (
                    <LazyIconCodesandbox
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'coffee':
                return (
                    <LazyIconCoffee
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'coin-stack':
                return (
                    <LazyIconCoinStack
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'coins':
                return (
                    <LazyIconCoins
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'columns':
                return (
                    <LazyIconColumns
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'command':
                return (
                    <LazyIconCommand
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'compass':
                return (
                    <LazyIconCompass
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'copy':
                return (
                    <LazyIconCopy
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'corner-down-left':
                return (
                    <LazyIconCornerDownLeft
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'corner-down-right':
                return (
                    <LazyIconCornerDownRight
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'corner-left-down':
                return (
                    <LazyIconCornerLeftDown
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'corner-left-up':
                return (
                    <LazyIconCornerLeftUp
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'corner-right-down':
                return (
                    <LazyIconCornerRightDown
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'corner-right-up':
                return (
                    <LazyIconCornerRightUp
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'corner-up-left':
                return (
                    <LazyIconCornerUpLeft
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'corner-up-right':
                return (
                    <LazyIconCornerUpRight
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'cpu':
                return (
                    <LazyIconCpu
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'credit-card':
                return (
                    <LazyIconCreditCard
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'crop':
                return (
                    <LazyIconCrop
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'crosshair':
                return (
                    <LazyIconCrosshair
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'database':
                return (
                    <LazyIconDatabase
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'delete':
                return (
                    <LazyIconDelete
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'disc':
                return (
                    <LazyIconDisc
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'divide-circle':
                return (
                    <LazyIconDivideCircle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'divide-square':
                return (
                    <LazyIconDivideSquare
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'divide':
                return (
                    <LazyIconDivide
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'divider':
                return (
                    <LazyIconDivider
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'dollar-sign':
                return (
                    <LazyIconDollarSign
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'download-cloud':
                return (
                    <LazyIconDownloadCloud
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'download':
                return (
                    <LazyIconDownload
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'dribbble':
                return (
                    <LazyIconDribbble
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'droplet':
                return (
                    <LazyIconDroplet
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'edit2':
                return (
                    <LazyIconEdit2
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'edit3':
                return (
                    <LazyIconEdit3
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'edit':
                return (
                    <LazyIconEdit
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'external-link':
                return (
                    <LazyIconExternalLink
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'eye-off':
                return (
                    <LazyIconEyeOff
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'eye':
                return (
                    <LazyIconEye
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'facebook':
                return (
                    <LazyIconFacebook
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'fast-forward':
                return (
                    <LazyIconFastForward
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'feather':
                return (
                    <LazyIconFeather
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'figma':
                return (
                    <LazyIconFigma
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'file-minus':
                return (
                    <LazyIconFileMinus
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'file-plus':
                return (
                    <LazyIconFilePlus
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'file-text':
                return (
                    <LazyIconFileText
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'file':
                return (
                    <LazyIconFile
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'film':
                return (
                    <LazyIconFilm
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'filter':
                return (
                    <LazyIconFilter
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'flag':
                return (
                    <LazyIconFlag
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'folder-minus':
                return (
                    <LazyIconFolderMinus
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'folder-plus':
                return (
                    <LazyIconFolderPlus
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'folder':
                return (
                    <LazyIconFolder
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'framer':
                return (
                    <LazyIconFramer
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'frown':
                return (
                    <LazyIconFrown
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'gift':
                return (
                    <LazyIconGift
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'git-branch':
                return (
                    <LazyIconGitBranch
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'git-commit':
                return (
                    <LazyIconGitCommit
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'git-merge':
                return (
                    <LazyIconGitMerge
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'git-pull-request':
                return (
                    <LazyIconGitPullRequest
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'github':
                return (
                    <LazyIconGithub
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'gitlab':
                return (
                    <LazyIconGitlab
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'globe':
                return (
                    <LazyIconGlobe
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'grid':
                return (
                    <LazyIconGrid
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'hard-drive':
                return (
                    <LazyIconHardDrive
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'hash':
                return (
                    <LazyIconHash
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'headphones':
                return (
                    <LazyIconHeadphones
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'heart':
                return (
                    <LazyIconHeart
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'help-circle':
                return (
                    <LazyIconHelpCircle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'hexagon':
                return (
                    <LazyIconHexagon
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'home':
                return (
                    <LazyIconHome
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'image':
                return (
                    <LazyIconImage
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'inbox':
                return (
                    <LazyIconInbox
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'info':
                return (
                    <LazyIconInfo
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'instagram':
                return (
                    <LazyIconInstagram
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'italic':
                return (
                    <LazyIconItalic
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'key':
                return (
                    <LazyIconKey
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'layers':
                return (
                    <LazyIconLayers
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'layout':
                return (
                    <LazyIconLayout
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'life-buoy':
                return (
                    <LazyIconLifeBuoy
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'link2':
                return (
                    <LazyIconLink2
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'link':
                return (
                    <LazyIconLink
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'linkedin':
                return (
                    <LazyIconLinkedin
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'list':
                return (
                    <LazyIconList
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'loader':
                return (
                    <LazyIconLoader
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'location-pin':
                return (
                    <LazyIconLocationPin
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'lock':
                return (
                    <LazyIconLock
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'log-in':
                return (
                    <LazyIconLogIn
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'log-out':
                return (
                    <LazyIconLogOut
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'mail':
                return (
                    <LazyIconMail
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'map-pin':
                return (
                    <LazyIconMapPin
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'map':
                return (
                    <LazyIconMap
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'maximize2':
                return (
                    <LazyIconMaximize2
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'maximize':
                return (
                    <LazyIconMaximize
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'meh':
                return (
                    <LazyIconMeh
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'menu2':
                return (
                    <LazyIconMenu2
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'menu':
                return (
                    <LazyIconMenu
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'message-circle':
                return (
                    <LazyIconMessageCircle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'message-square':
                return (
                    <LazyIconMessageSquare
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'mic-off':
                return (
                    <LazyIconMicOff
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'mic':
                return (
                    <LazyIconMic
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'minimize2':
                return (
                    <LazyIconMinimize2
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'minimize':
                return (
                    <LazyIconMinimize
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'minus-circle':
                return (
                    <LazyIconMinusCircle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'minus-square':
                return (
                    <LazyIconMinusSquare
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'minus':
                return (
                    <LazyIconMinus
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'monitor':
                return (
                    <LazyIconMonitor
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'moon':
                return (
                    <LazyIconMoon
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'more-horizontal':
                return (
                    <LazyIconMoreHorizontal
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'more-vertical':
                return (
                    <LazyIconMoreVertical
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'mouse-pointer':
                return (
                    <LazyIconMousePointer
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'move':
                return (
                    <LazyIconMove
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'music':
                return (
                    <LazyIconMusic
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'navigation2':
                return (
                    <LazyIconNavigation2
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'navigation':
                return (
                    <LazyIconNavigation
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'octagon':
                return (
                    <LazyIconOctagon
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'package':
                return (
                    <LazyIconPackage
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'paperclip':
                return (
                    <LazyIconPaperclip
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'pause-circle':
                return (
                    <LazyIconPauseCircle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'pause':
                return (
                    <LazyIconPause
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'pen-tool':
                return (
                    <LazyIconPenTool
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'percent':
                return (
                    <LazyIconPercent
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'phone-call':
                return (
                    <LazyIconPhoneCall
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'phone-forwarded':
                return (
                    <LazyIconPhoneForwarded
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'phone-incoming':
                return (
                    <LazyIconPhoneIncoming
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'phone-missed':
                return (
                    <LazyIconPhoneMissed
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'phone-off':
                return (
                    <LazyIconPhoneOff
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'phone-outgoing':
                return (
                    <LazyIconPhoneOutgoing
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'phone':
                return (
                    <LazyIconPhone
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'pie-chart':
                return (
                    <LazyIconPieChart
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'play-circle':
                return (
                    <LazyIconPlayCircle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'play':
                return (
                    <LazyIconPlay
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'plus-circle':
                return (
                    <LazyIconPlusCircle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'plus-square':
                return (
                    <LazyIconPlusSquare
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'plus':
                return (
                    <LazyIconPlus
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'pocket':
                return (
                    <LazyIconPocket
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'power':
                return (
                    <LazyIconPower
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'printer':
                return (
                    <LazyIconPrinter
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'radio':
                return (
                    <LazyIconRadio
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'rating':
                return (
                    <LazyIconRating
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'refresh-ccw':
                return (
                    <LazyIconRefreshCcw
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'refresh-cw':
                return (
                    <LazyIconRefreshCw
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'repeat':
                return (
                    <LazyIconRepeat
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'rewind':
                return (
                    <LazyIconRewind
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'rocket':
                return (
                    <LazyIconRocket
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'rotate-ccw':
                return (
                    <LazyIconRotateCcw
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'rotate-cw':
                return (
                    <LazyIconRotateCw
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'rss':
                return (
                    <LazyIconRss
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'save':
                return (
                    <LazyIconSave
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'scissors':
                return (
                    <LazyIconScissors
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'search':
                return (
                    <LazyIconSearch
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'send':
                return (
                    <LazyIconSend
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'server':
                return (
                    <LazyIconServer
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'settings':
                return (
                    <LazyIconSettings
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'share2':
                return (
                    <LazyIconShare2
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'share':
                return (
                    <LazyIconShare
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'shield-off':
                return (
                    <LazyIconShieldOff
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'shield':
                return (
                    <LazyIconShield
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'shopping-bag':
                return (
                    <LazyIconShoppingBag
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'shopping-cart':
                return (
                    <LazyIconShoppingCart
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'shuffle':
                return (
                    <LazyIconShuffle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'sidebar':
                return (
                    <LazyIconSidebar
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'skip-back':
                return (
                    <LazyIconSkipBack
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'skip-forward':
                return (
                    <LazyIconSkipForward
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'slack':
                return (
                    <LazyIconSlack
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'slash-divider':
                return (
                    <LazyIconSlashDivider
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'slash':
                return (
                    <LazyIconSlash
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'sliders':
                return (
                    <LazyIconSliders
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'smartphone':
                return (
                    <LazyIconSmartphone
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'smile':
                return (
                    <LazyIconSmile
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'speaker':
                return (
                    <LazyIconSpeaker
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'square':
                return (
                    <LazyIconSquare
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'star':
                return (
                    <LazyIconStar
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'stop-circle':
                return (
                    <LazyIconStopCircle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'sun':
                return (
                    <LazyIconSun
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'sunrise':
                return (
                    <LazyIconSunrise
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'sunset':
                return (
                    <LazyIconSunset
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'table':
                return (
                    <LazyIconTable
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'tablet':
                return (
                    <LazyIconTablet
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'tag':
                return (
                    <LazyIconTag
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'target':
                return (
                    <LazyIconTarget
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'terminal':
                return (
                    <LazyIconTerminal
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'thermometer':
                return (
                    <LazyIconThermometer
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'thumbs-down':
                return (
                    <LazyIconThumbsDown
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'thumbs-up':
                return (
                    <LazyIconThumbsUp
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'toggle-left':
                return (
                    <LazyIconToggleLeft
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'toggle-right':
                return (
                    <LazyIconToggleRight
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'tool':
                return (
                    <LazyIconTool
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'trash2':
                return (
                    <LazyIconTrash2
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'trash':
                return (
                    <LazyIconTrash
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'trello':
                return (
                    <LazyIconTrello
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'trending-down':
                return (
                    <LazyIconTrendingDown
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'trending-up':
                return (
                    <LazyIconTrendingUp
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'triangle':
                return (
                    <LazyIconTriangle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'truck':
                return (
                    <LazyIconTruck
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'tv':
                return (
                    <LazyIconTv
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'twitch':
                return (
                    <LazyIconTwitch
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'twitter':
                return (
                    <LazyIconTwitter
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'type':
                return (
                    <LazyIconType
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'umbrella':
                return (
                    <LazyIconUmbrella
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'underline':
                return (
                    <LazyIconUnderline
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'unlock':
                return (
                    <LazyIconUnlock
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'upload-cloud':
                return (
                    <LazyIconUploadCloud
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'upload':
                return (
                    <LazyIconUpload
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'user-check':
                return (
                    <LazyIconUserCheck
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'user-minus':
                return (
                    <LazyIconUserMinus
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'user-plus':
                return (
                    <LazyIconUserPlus
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'user-x':
                return (
                    <LazyIconUserX
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'user':
                return (
                    <LazyIconUser
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'users':
                return (
                    <LazyIconUsers
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'video-off':
                return (
                    <LazyIconVideoOff
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'video-play-circle':
                return (
                    <LazyIconVideoPlayCircle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'video':
                return (
                    <LazyIconVideo
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'voicemail':
                return (
                    <LazyIconVoicemail
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'volume1':
                return (
                    <LazyIconVolume1
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'volume2':
                return (
                    <LazyIconVolume2
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'volume-x':
                return (
                    <LazyIconVolumeX
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'volume':
                return (
                    <LazyIconVolume
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'watch':
                return (
                    <LazyIconWatch
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'wifi-off':
                return (
                    <LazyIconWifiOff
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'wifi':
                return (
                    <LazyIconWifi
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'wind':
                return (
                    <LazyIconWind
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'x-circle':
                return (
                    <LazyIconXCircle
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'x-octagon':
                return (
                    <LazyIconXOctagon
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'x-square':
                return (
                    <LazyIconXSquare
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'x':
                return (
                    <LazyIconX
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'youtube':
                return (
                    <LazyIconYoutube
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'zap-off':
                return (
                    <LazyIconZapOff
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'zap':
                return (
                    <LazyIconZap
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'zoom-in':
                return (
                    <LazyIconZoomIn
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
case 'zoom-out':
                return (
                    <LazyIconZoomOut
                        ref={ref}
                        fallback={
                            <span
                                data-icon-suspense={name}
                                className={props.className}
                                style={{
                                    height: ICON_SIZE[props.size] ?? props.size ?? props.height ?? '1em',
                                    width: ICON_SIZE[props.size] ?? props.size ?? props.width ?? '1em',
                                }}
                            />
                        }
                        {...otherProps} />
                    );
                            default:
                                throw new Error('Invalid icon name: ', name)
                        }
                    })()}
                </>
            );
        });

        Icon.displayName = 'Icon';

        Icon.propTypes = {
            /**
             * Icon name
             */
            name: PropTypes.oneOf([
                '2-layers','3-dots','3-layers','filters-lines','activity','airplay','alert-circle','alert-octagon','alert-triangle','align-center','align-justify','align-left','align-right','anchor','aperture','archive','arrow-down-circle','arrow-down-left','arrow-down-right','arrow-down','arrow-left-circle','arrow-left','arrow-right-circle','arrow-right','arrow-up-circle','arrow-up-left','arrow-up-right','arrow-up','at-sign','award','bar-chart2','bar-chart','battery-charging','battery','bell-off','bell','bluetooth','bold','book-open','book','bookmark','box','briefcase','calendar','camera-off','camera','cast','check-circle','check-square','check','chevron-down','chevron-left','chevron-right','chevron-up','chevrons-down','chevrons-left','chevrons-right','chevrons-up','chrome','circle','clipboard','clock','cloud-drizzle','cloud-lightning','cloud-off','cloud-rain','cloud-snow','cloud','code','codepen','codesandbox','coffee','coin-stack','coins','columns','command','compass','copy','corner-down-left','corner-down-right','corner-left-down','corner-left-up','corner-right-down','corner-right-up','corner-up-left','corner-up-right','cpu','credit-card','crop','crosshair','database','delete','disc','divide-circle','divide-square','divide','divider','dollar-sign','download-cloud','download','dribbble','droplet','edit2','edit3','edit','external-link','eye-off','eye','facebook','fast-forward','feather','figma','file-minus','file-plus','file-text','file','film','filter','flag','folder-minus','folder-plus','folder','framer','frown','gift','git-branch','git-commit','git-merge','git-pull-request','github','gitlab','globe','grid','hard-drive','hash','headphones','heart','help-circle','hexagon','home','image','inbox','info','instagram','italic','key','layers','layout','life-buoy','link2','link','linkedin','list','loader','location-pin','lock','log-in','log-out','mail','map-pin','map','maximize2','maximize','meh','menu2','menu','message-circle','message-square','mic-off','mic','minimize2','minimize','minus-circle','minus-square','minus','monitor','moon','more-horizontal','more-vertical','mouse-pointer','move','music','navigation2','navigation','octagon','package','paperclip','pause-circle','pause','pen-tool','percent','phone-call','phone-forwarded','phone-incoming','phone-missed','phone-off','phone-outgoing','phone','pie-chart','play-circle','play','plus-circle','plus-square','plus','pocket','power','printer','radio','rating','refresh-ccw','refresh-cw','repeat','rewind','rocket','rotate-ccw','rotate-cw','rss','save','scissors','search','send','server','settings','share2','share','shield-off','shield','shopping-bag','shopping-cart','shuffle','sidebar','skip-back','skip-forward','slack','slash-divider','slash','sliders','smartphone','smile','speaker','square','star','stop-circle','sun','sunrise','sunset','table','tablet','tag','target','terminal','thermometer','thumbs-down','thumbs-up','toggle-left','toggle-right','tool','trash2','trash','trello','trending-down','trending-up','triangle','truck','tv','twitch','twitter','type','umbrella','underline','unlock','upload-cloud','upload','user-check','user-minus','user-plus','user-x','user','users','video-off','video-play-circle','video','voicemail','volume1','volume2','volume-x','volume','watch','wifi-off','wifi','wind','x-circle','x-octagon','x-square','x','youtube','zap-off','zap','zoom-in','zoom-out'
            ]),
            /**
             * Icon title
             */
            title: PropTypes.string,
            /**
             * Icon title ID
             */
            titleId: PropTypes.string,
            /**
             * Icon description
             */
            desc: PropTypes.string,
            /**
             * Icon description ID
             */
            descId: PropTypes.string,
            /**
             * Size of the icon, these values are based on 'rem'
             * to make it adjustable to the user browser configuration.
             */
            size: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['small', 'medium', 'large'])]),
        }
    